import React from "react"

import { Spinner } from "components"
import classes from "./InfiniteScrollLoader.module.scss"

const InfiniteScrollLoader = () => {
  return (
    <div className={classes["container"]}>
      <Spinner />
    </div>
  )
}

export default InfiniteScrollLoader